interface AssignmentBadgeProps {
  assignments: Array<{ userId: string; username: string }>;
  maxVisible?: number;
}

export function AssignmentBadge({ assignments, maxVisible = 3 }: AssignmentBadgeProps) {
  if (assignments.length === 0) return null;

  const visible = assignments.slice(0, maxVisible);
  const overflow = assignments.length - maxVisible;

  return (
    <div className="flex items-center -space-x-1.5 flex-shrink-0">
      {visible.map((a) => (
        <div
          key={a.userId}
          className="h-5 w-5 rounded-full bg-primary/15 border border-background flex items-center justify-center text-[9px] font-medium text-primary"
          title={a.username}
        >
          {a.username[0].toUpperCase()}
        </div>
      ))}
      {overflow > 0 && (
        <div className="h-5 w-5 rounded-full bg-muted border border-background flex items-center justify-center text-[9px] font-medium text-muted-foreground">
          +{overflow}
        </div>
      )}
    </div>
  );
}
